import React from 'react';
import { Helmet } from 'react-helmet';

const GoogleAnalytic = () => {
  return (
    <Helmet>
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-7HZ96R9XSJ" />
      <script>
        {`window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', 'G-7HZ96R9XSJ');
            gtag('config', 'AW-924816329');`}
      </script>
    </Helmet>
  );
};

export default GoogleAnalytic;
